import { request } from '../../lib/request_npgw';
import { request as requestNoFormat } from '../../lib/request_noformat';

// 菜单列表信息 通过租户id查询租户菜单信息
export function getMenuListByTenantId(data) {
    return requestNoFormat({
        url: '{#npgw}/pms/pcpTenantMenu/getMenuListByTenantId',
        method: 'post',
        data,
    });
}
//新菜单接口
export function getCustomMenuListByTenantId(data) {
    return requestNoFormat({
        url: '{#npgw}/pms/pcpTenantCustomMenu/v2/getCustomMenuListByTenantId',
        method: 'get',
        data,
    });
}
//根据appId查应用菜单接口
export function getSystemMenuListByAppCode(data) {
    return requestNoFormat({
        url: '{#npgw}/pms/pcpTenantMenu/getSystemMenuListByAppCode',
        method: 'post',
        data,
        dataType: 'form',
    });
}

// 权限角色 根据角色id查询角色以及角色对应的权限信息
// roleId * integer($int32)(query) roleId
// tenantId * integer($int64)(query) 租户id
export function getRolePermissionListByRoleId(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/getRolePermissionListByRoleId',
        method: 'post',
        prop: {
            roleId: {
                type: 'integer',
                required: true,
                message: 'not null',
            },
        },
        data,
    });
}

// 账号角色 通过用户id查询权限信息
export function getPermissionListByUserId(data, params) {
    return request({
        url: '{#npgw}/pms/pcpUser/getPermissionListByUserId',
        method: 'post',
        prop: {
            userId: {
                type: 'string',
                required: true,
                message: 'userId not null',
            },
        },
        data,
        params
    });
}

//角色列表 /pcpPermissionRole/getRoleListByTenantId
export function getRoleListByTenantId(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/getRoleListByTenantId',
        method: 'post',
        prop: {
            pageNum: {
                type: 'integer',
                required: true,
                message: 'pageNum not null',
            },
            pageSize: {
                type: 'integer',
                required: true,
                message: 'pageSize not null',
            },
            roleName: {
                type: 'string',
                message: 'roleName not null',
            },
        },
        data,
    });
}
// 根据租户获取所有的角色列表 /pms/pcpRole/getRoleList
// tenantId integer(query) 租户id
export function getRoleList() {
    return request({
        url: '{#npgw}/pms/pcpRole/getRoleList',
        method: 'post',
    });
}

// 通过用户id查询用户有哪些角色 /pcpUser/getRoleListByUserId post
// tenantId * integer($int64)(query) 租户id
// userId * string(query) member_code
export function getRoleListByUserId(data) {
    return request({
        url: '{#npgw}/pms/pcpUser/getRoleListByUserId',
        method: 'post',
        prop: {
            userId: {
                type: 'string',
                required: true,
                message: 'userId not null',
            },
        },
        data,
    });
}

//新建角色 /pcpPermissionRole/add
// roleDesc string(query)	角色描述
// roleName *string(query)	角色名称
export function addRole(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/add',
        method: 'post',
        prop: {
            custId: {
                type: 'string',
                required: true,
                message: 'custId not null',
            },
            roleName: {
                type: 'string',
                required: true,
                message: 'roleName not null',
            },
            roleDesc: {
                type: 'string',
            },
        },
        data,
    });
}

// /pcpUser/addUserRole 给对应的用户添加角色列表信息
// roleIdList * string(query)	角色标识集合
// tenantId * string(query)  租户id
// userId * string(query) 用户标识 // 张富强 孙乐乐确定 membercode
export function addUserRole(data) {
    return request({
        url: '{#npgw}/pms/pcpUser/addUserRole',
        method: 'post',
        prop: {
            roleIdList: {
                type: 'string',
                required: true,
                message: 'roleIdList not null',
            },
            userId: {
                type: 'string',
                required: true,
                message: 'userId not null',
            },
        },
        data,
    });
}

//编辑角色 /pcpPermissionRole/update
// id * integer(query)	主键id
// permissionCodeList string(query) 权限集合
// roleDesc string(query)	角色描述
// roleName *string(query)	角色名称
export function updateRole(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/update',
        method: 'post',
        prop: {
            id: {
                type: 'integer',
                required: true,
                message: 'id not null',
            },
            roleName: {
                type: 'string',
                required: true,
                message: 'roleName not null',
            },
            roleDesc: {
                type: 'string',
            },
            permissionCodeList: {
                type: 'string',
            },
        },
        data,
    });
}

//删除角色 /pcpPermissionRole/deleteRole
export function deleteRole(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/deleteRole',
        method: 'post',
        prop: {
            roleId: {
                type: 'integer',
                required: true,
                message: 'roleId not null',
            },
        },
        data,
    });
}

// 根据角色id删除没有引用的 /pms/pcpRole/deleteRoleById
export function deleteRoleById(data) {
    return request({
        url: '{#npgw}/pms/pcpRole/deleteRoleById',
        method: 'post',
        prop: {
            id: {
                type: 'integer',
                required: true,
                message: 'deleteRoleById id not null',
            },
        },
        data,
    });
}

//给对应的角色新增权限 /pcpPermissionRole/addPermissionList
export function addPermissionList(data) {
    return request({
        url: '{#npgw}/pms/pcpPermissionRole/addPermissionList',
        method: 'post',
        prop: {
            permissionCodeList: {
                type: 'string',
                required: true,
                message: 'permissionCodeList not null',
            },
            roleId: {
                type: 'integer',
                required: true,
                message: 'roleId not null',
            },
        },
        data,
    });
}



// 数字门户角色列表接口 带分页
// /userRolePermission/pageRolesBy
export function getNumberPortalRoleList(params) {
    return request({
        url: '{#npgw}/common-layer/userRolePermission/pageRolesBy',
        method: 'get',
        params
    });
}